import React, { MouseEvent } from 'react'
import cx from 'classnames'
import { TickIcon } from 'components/common'

type Props = {
  onClick: (event: MouseEvent<HTMLDivElement>) => void
  isActive: boolean
  children: React.ReactNode | React.ReactNode[]
  className: string
}

const Box = ({ onClick, isActive, children, className }: Props) => {
  return (
    <div
      className={cx(
        className,
        'border-2 border-solid cursor-pointer rounded-md p-4 flex flex-col hover:bg-gray-100 bg-white relative min-h-[150px]',
        {
          'border-green': isActive,
          'border-black': !isActive
        }
      )}
      onClick={onClick}
    >
      {children}

      {isActive && (
        <TickIcon
          style={{ margin: '0px' }}
          className="absolute w-10 h-10 sm:w-12 sm:h-12 right-4 top-1/2 md:top-1/2 -translate-y-1/2 "
        />
      )}
    </div>
  )
}

export default Box
